import { useState } from 'react';
import MaterialIcon from 'material-icons-react';
import CookiesService from '../../../services/cookies';

const SortArrow = ({ direction }) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" style={{ marginLeft: 6, verticalAlign: 'middle', cursor: 'pointer' }}>
            {direction === 'up' ? (
                <path d="M6 3l4 6H2z" fill="#fff" />
            ) : (
                <path d="M6 9l-4-6h8z" fill="#fff" />
            )}
        </svg>
    );
};

const useMainTable = ({
    mainData,
    setMainData,
    isRevisorView,
    checkedRows,
    handleCheckboxChange,
    handleShowPDF,
    handleRowClick
}) => {
    const [sortConfig, setSortConfig] = useState({ column: null, direction: 'down' });
    const userSupplierPitagoras = CookiesService.getUserSupplierPitagoras();

    const handleSortClick = (columnKey) => {
        setSortConfig(prev => {
            if (prev.column === columnKey && prev.direction === 'up') {
                setMainData([...mainData].reverse());
                return { column: columnKey, direction: 'down' };
            } else {
                setMainData([...mainData].reverse());
                return { column: columnKey, direction: 'up' };
            }
        });
    };

    let reportColumns = [
        {
            name: <span>ID <span onClick={() => handleSortClick('idMpTriangulacaoRev')}><SortArrow direction={sortConfig.column === 'idMpTriangulacaoRev' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => (
                <div style={{ position: 'relative', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ minWidth: 40, textAlign: 'right', fontVariantNumeric: 'tabular-nums', display: 'block', marginRight: '15px' }}>
                        {row.idMpTriangulacaoRev || 'N/A'}
                    </span>
                </div>
            ),
        },
        {
            name: 'Laudo',
            selector: row => row.idMpTriangulacaoRev,
            cell: row => {
                return (
                    row.arquivoLaudo ?
                        <span key={row.idMpTriangulacaoRev} style={{ cursor: 'pointer' }}>
                            <MaterialIcon icon='description' color='#344051ff' size={30} onClick={() => handleShowPDF(row.arquivoLaudo)} />
                        </span>
                        : null
                )
            }
        },
        {
            name: <span>Pedido <span onClick={() => handleSortClick('pedido')}><SortArrow direction={sortConfig.column === 'pedido' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => row.pedido || 'N/A'
        },
        {
            name: <span>Material <span onClick={() => handleSortClick('material')}><SortArrow direction={sortConfig.column === 'material' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => row.material || 'N/A'
        },
        {
            name: <span>Cor <span onClick={() => handleSortClick('cor')}><SortArrow direction={sortConfig.column === 'cor' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => row.corMaterial || 'N/A'
        },
        {
            name: <span>Fornecedor <span onClick={() => handleSortClick('fornecedor')}><SortArrow direction={sortConfig.column === 'fornecedor' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => row.fornecedor || 'N/A'
        },
        {
            name: <span>Desc.Material <span onClick={() => handleSortClick('descMaterial')}><SortArrow direction={sortConfig.column === 'descMaterial' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => <span title={row.descMaterial}>{row.descMaterial || 'N/A'}</span>
        },
        {
            name: <span>Desc.Cor <span onClick={() => handleSortClick('descCor')}><SortArrow direction={sortConfig.column === 'descCor' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => <span title={row.descCor} style={{ marginLeft: '15px', display: 'inline-block', maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.descCor || 'N/A'}</span>
        },
        {
            name: <span>Qtde.Peças <span onClick={() => handleSortClick('qtdePecas')}><SortArrow direction={sortConfig.column === 'qtdePecas' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => row.qtdePecas || 'N/A'
        },
        {
            name: <span>Qtde Entregar <span onClick={() => handleSortClick('qtdeEntregar')}><SortArrow direction={sortConfig.column === 'qtdeEntregar' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => row.qtdeEntregar || 'N/A',
        },
        {
            name: <span>Status <span onClick={() => handleSortClick('Status')}><SortArrow direction={sortConfig.column === 'Status' ? sortConfig.direction : 'down'} /></span></span>,
            selector: row => <span title={row.statusRevisao || 'N/A'}>{row.statusRevisao || 'N/A'}</span>
        },
    ];

    if (!isRevisorView && !userSupplierPitagoras) {
        reportColumns = [
            ...reportColumns,
            {
                name: '',
                selector: row => {
                    let longPressTimer = null;
                    const showTooltip = (target) => {
                        const tooltip = document.createElement('div');
                        tooltip.innerText = 'Deseja marcar auditoria?';
                        tooltip.style.position = 'absolute';
                        tooltip.style.top = '30px';
                        tooltip.style.left = '-120px';
                        tooltip.style.background = '#202D3B';
                        tooltip.style.color = '#fff';
                        tooltip.style.padding = '4px 12px';
                        tooltip.style.borderRadius = '6px';
                        tooltip.style.fontSize = '0.85rem';
                        tooltip.style.whiteSpace = 'nowrap';
                        tooltip.style.zIndex = '9999';
                        tooltip.className = 'checkbox-tooltip';
                        target.parentNode.appendChild(tooltip);
                    };
                    const hideTooltip = (target) => {
                        const tooltip = target.parentNode.querySelector('.checkbox-tooltip');
                        if (tooltip) tooltip.remove();
                    };
                    return (
                        <span style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 4 }}>
                            <input
                                type="checkbox"
                                style={{ width: 22, height: 22, accentColor: '#202D3B', cursor: 'pointer' }}
                                checked={!!checkedRows[row.idMpTriangulacaoRev]}
                                onChange={e => { e.stopPropagation(); handleCheckboxChange(row.idMpTriangulacaoRev)(e); }}
                                onMouseEnter={e => showTooltip(e.target)}
                                onMouseLeave={e => hideTooltip(e.target)}
                                onTouchStart={e => {
                                    if (window.matchMedia('(pointer: coarse)').matches) {
                                        longPressTimer = setTimeout(() => {
                                            showTooltip(e.target);
                                        }, 500);
                                    }
                                }}
                                onTouchEnd={e => {
                                    if (longPressTimer) {
                                        clearTimeout(longPressTimer);
                                        longPressTimer = null;
                                    }
                                    hideTooltip(e.target);
                                }}
                                onTouchCancel={e => {
                                    if (longPressTimer) {
                                        clearTimeout(longPressTimer);
                                        longPressTimer = null;
                                    }
                                    hideTooltip(e.target);
                                }}
                            />
                        </span>
                    );
                },
                center: true,
                width: '60px',
                ignoreRowClick: false,
                allowOverflow: true,
            }
        ];
    }

    const customStyles = {
        headCells: { style: { backgroundColor: '#202D3B', justifyContent: 'center', color: '#fff', marginLeft: '0px', paddingLeft: '-40px', minWidth: '120px', width: '120px' } },
        rows: { style: { marginLeft: '-24px', paddingRight: '5px', cursor: 'pointer' } },
        cells: { style: { justifyContent: 'center', marginLeft: '13px', minWidth: '120px', width: '120px' } },
        headRow: { style: { marginLeft: '-10px' } },
    };

    return {
        columns: reportColumns,
        customStyles: customStyles
    };
};

export default useMainTable;